import styled, { keyframes, CSSObject, css } from 'styled-components';
import { defaultProps } from '../callout-default-props';
import { ICalloutProps, ICalloutPositionStyles } from '../callout-types';

const popoutAnimation = keyframes`
    from {
        transform: scale(0);
    }
    80% {
        transform: scale(1.03);
    }
    to {
        transform: scale(1);
    }
`;

interface ICalloutWrapperProps {
    $animateOnOpen: ICalloutProps['animateOnOpen'];
    $contentPositionStyles: ICalloutPositionStyles['contentPositionStyles']
    $showModal?: boolean;
}

export const CalloutWrapper = styled.div.attrs({
    tabIndex: 0,
    className: String('ap-callout')
}) <ICalloutWrapperProps>`
    ${({ $contentPositionStyles }) => $contentPositionStyles as CSSObject}
    background-color: ${({ theme: { callout: { colors } } }) => colors.backgroundColor};
    border-width: ${({ theme: { callout: { composites } } }) => composites.borderWidth};
    border-style: ${({ theme: { callout: { composites } } }) => composites.borderStyle};
    border-color: ${({ theme: { callout: { colors } } }) => colors.borderColor};
    border-radius: ${({ theme: { callout: { composites } } }) => composites.borderRaduis};
    box-shadow: ${({ theme: { callout: { composites } }, $showModal }) => ($showModal ? 'transparent' : composites.boxShadow)};
    color: ${({ theme: { callout: { colors } } }) => colors.foregroundColor};
    ${({ $animateOnOpen = defaultProps.animateOnOpen }) => $animateOnOpen && css`animation: ${popoutAnimation} 0.1s ease;`}
    box-sizing: border-box;
    overflow: visible;
    position: absolute;
    visibility: visible;
    opacity: 1;
    z-index: 10;
    outline: none;
`;
